/* import __COLOCATED_TEMPLATE__ from './snapshot-item.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import type { Snapshot } from './side-sheet';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';
import type Workflow from 'embercom/models/operator/visual-builder/workflow';

interface Signature {
  Args: {
    snapshot: Snapshot;
    workflow: Workflow;
    editorState: EditorState;
    hasDraft: boolean;
  };
  Element: HTMLLIElement;
}

export default class SnapshotItem extends Component<Signature> {
  get showRollbackButton() {
    return !this.args.snapshot.is_current && !this.args.snapshot.is_draft;
  }

  get isRollbackDisabled() {
    return this.args.hasDraft;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::VersionHistory::SnapshotItem': typeof SnapshotItem;
    'workflows/version-history/snapshot-item': typeof SnapshotItem;
  }
}
